import React from 'react';

import RoleSideNav from './RoleSideNav';
import { NavContext, RESELLER_NAV_GROUPS } from './sideNavConfig';

const RESELLER_CONTEXT: NavContext = {
  isSpectator: false,
  isReadOnly: false,
};

const ResellerNavbar: React.FC = () => (
  <RoleSideNav
    context={RESELLER_CONTEXT}
    groups={RESELLER_NAV_GROUPS}
    ariaLabel="Reseller navigation"
    collapseStorageKey="gc_reseller_nav_collapsed_v1"
    openStorageKey="gc_reseller_nav_open_v1"
  />
);

export default ResellerNavbar;
